<template lang="pug">
div
  signup(v-if="page === 'signup'")
  signin(v-else-if="page === 'signin'")
  forgot(v-else-if="page === 'forgot'")
  reset-password(v-else-if="page === 'reset'")

  .page-account.with-nav.myaccount(v-if="page !== '' && page !== 'signup' && page != 'signin' && page != 'forgot' && page != 'reset'")
    h1 My Account
    .content
      .nav
        ul(role="tablist" aria-orientation="vertical")
          li(role="presentation")
            a(
              :class="page == 'profile' && 'active'",
              role="tab",
              href="#",
              @click.prevent="setPage('profile')",
              :aria-selected="(page === 'profile').toString()"
              aria-controls="profile"
            ) Account Information
          li(role="presentation")
            a(
              :class="page == 'addresses' && 'active'",
              role="tab",
              href="#",
              @click.prevent="setPage('addresses')",
              tabindex="-1",
              :aria-selected="(page === 'addresses').toString()"
              aria-controls="addresses"
            ) View Addresses
          li(role="presentation")
            a(
              :class="page == 'notification_preferences' && 'active'",
              role="tab",
              href="#",
              @click.prevent="setPage('notification_preferences')",
              tabindex="-1",
              :aria-selected="(page === 'notification_preferences').toString()"
              aria-controls="notification_preferences"
            ) Notification Preferences
          li(role="presentation")
            a(
              :class="page == 'orders' && 'active'",
              role="tab",
              href="#",
              @click.prevent="setPage('orders')",
              tabindex="-1",
              :aria-selected="(page === 'orders').toString()"
              aria-controls="orders"
            ) Orders
          li(role="presentation")
            a(
              :class="page == 'subscriptions' && 'active'",
              role="tab",
              href="#",
              @click.prevent="setPage('subscriptions')",
              tabindex="-1",
              :aria-selected="(page === 'subscriptions').toString()"
              aria-controls="subscriptions"
            ) Subscription Orders
          li(role="presentation")
            a(
              :class="page == 'logout' && 'active'",
              href="#",
              tabindex="0"
              @click.prevent="setPage('logout')",
            ) Logout
      div
        profile(
          v-if="page === 'profile'",
          id="profile",
          role="tabpanel",
          ref="page"
        )
        addresses(
          v-if="page === 'addresses'",
          id="addresses",
          role="tabpanel",
          ref="page"
        )
        notification-preferences(
          v-if="page === 'notification_preferences'",
          id="notification_preferences",
          role="tabpanel",
          ref="page"
        )
        orders(
          v-if="page === 'orders'",
          id="orders",
          role="tabpanel",
          ref="page"
        )
        subscriptions(
          v-if="page === 'subscriptions'",
          id="subscriptions",
          role="tabpanel",
          ref="page"
        )
</template>

<script>
  import Signup from 'scripts/components/account/Signup.vue';
  import Signin from 'scripts/components/account/Signin.vue';
  import Forgot from 'scripts/components/account/Forgot.vue';
  import Profile from 'scripts/components/account/Profile.vue';
  import Addresses from 'scripts/components/account/Addresses.vue';
  import ResetPassword from 'scripts/components/account/ResetPassword.vue';
  import NotificationPreferences from 'scripts/components/account/NotificationPreferences.vue';
  import Subscriptions from 'scripts/components/account/Subscriptions.vue';
  import Orders from 'scripts/components/account/Orders.vue';
  import 'scripts/misc/misc.js';

  export default {
    name: 'Account',

    components: {
      Signup,
      Signin,
      Forgot,
      Profile,
      Addresses,
      ResetPassword,
      NotificationPreferences,
      Orders,
      Subscriptions
    },

    props: {
      customerId: null,
      serverUrl: null,
      storefrontAccessToken: null,
    },

    data() {
      return {
        page: '',
        // url: 'http://localhost:4000/ratiofood_dev/',
        url: this.serverUrl,
        recaptcha_key: '6Lf7GpsnAAAAABM1DuoTYWio5ZnN-5keiW0fE7Zj',
        tabs: ['profile', 'addresses', 'notification_preferences', 'orders', 'subscriptions']
      }
    },

    methods: {
      setSession(session) {
        if (session && session.cdata)
          window.localStorage.setItem('account', JSON.stringify({ cdata: session.cdata }));
        else
          window.localStorage.removeItem('account');
      },

      getSession() {
        if (!this.customerId)
          return null;
        const data = JSON.parse(window.localStorage.getItem('account'));
        if (!data || !data.cdata)
          return null;
        return data;
      },

      createRecaptcha() {
        if (!document.querySelector('script.recaptcha')) {
          const script = document.createElement('script');
          script.className = 'recaptcha';
          script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + this.recaptcha_key);
          document.body.appendChild(script);
        }
      },

      getRecaptchaToken(callback) {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.recaptcha_key, {action: 'submit'}).then((token) => {
            callback(token);
          })
        });
      },

      setPage(page) {
        if (!this.getSession() && ['signup', 'signin', 'forgot', 'reset'].indexOf(page) < 0)
          this.page = 'signin';
        else if (page == 'logout') {
          this.setSession(null);
          window.location = '/';
        } else
          this.page = page;

        if (this.$refs.page && typeof(this.$refs.page.resetPage) === 'function')
          this.$refs.page.resetPage();
      },

      logout(reload) {
        this.setSession(null);
        window.location = reload ? '/account' : '/account/logout';
      },

      handleArrowKeyNavigation(event) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          if (!this.tabs.includes(this.page) || !document.querySelector('a[role="tab"]:focus')) return;
          event.preventDefault();

          const currentIndex = this.tabs.indexOf(this.page);
          if (currentIndex === -1) return;

          let newIndex;
          if (event.key === 'ArrowDown') {
            newIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowUp') {
            newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          }

          this.page = this.tabs[newIndex];
          const clickedTab = document.querySelector(`a[aria-controls="${this.page}"]`);
          clickedTab.focus();
        }
      },

    },

    mounted() {
      if (window.location.hash == '#signout') {
        this.logout();
      } else if (window.location.hash && window.location.hash.startsWith('#reset-password')) {
        this.setPage('reset');
      } else {
        this.setPage('profile');
      }
      setTimeout(() => {
        const anchorLinks = document.querySelectorAll('a[role="tab"]');
        anchorLinks.forEach((link) => {
          link.addEventListener('focus', () => {
            anchorLinks.forEach((otherLink) => {
              if (otherLink !== link) {
                otherLink.setAttribute('tabindex', '-1');
              }
            });
            link.setAttribute('tabindex', '0');
          });
        });

        window.addEventListener('keydown', this.handleArrowKeyNavigation);
      }, 100);
    }
  }
</script>

<style scoped lang="scss">
</style>
